import { safeDivide } from "../math";

export const computeFractionPercent =
    (previousValue: number | null, value: number) =>
    (fractionPercentDefault: number): number => {
        if (previousValue === null) {
            return fractionPercentDefault;
        }

        if (value > 0 && previousValue === 0) {
            return Number.POSITIVE_INFINITY;
        }

        return safeDivide(value, previousValue) * 100;
    };
